// AppSidebar.tsx
import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "../assets/styles/components/_sidebar.scss";
import icon from "../assets/icons/1200x630wa.svg";

interface AppSidebarProps {
  userName: string;
  userRole: string;
  onNewAnalysis: () => void;
  onLogout: () => void;
  children?: React.ReactNode;
}

export const Sidebar: React.FC<AppSidebarProps> = ({
  userName,
  userRole,
  onNewAnalysis,
  onLogout,
  children,
}) => {
  const [logoutVisible, setLogoutVisible] = useState(false);

  const confirmLogout = () => {
    setLogoutVisible(false);
    onLogout();
  };

  return (
    <>
      <div id="sidebar" className="app-sidebar">
        <div className="company-header">
          <div className="company-logo">
            <img src={icon} alt="Visual Comfort Logo" />
          </div>

          <div className="company-text">
            <div className="company-line">
              <span className="company-main">Visual Comfort</span>
            </div>
            <div className="company-line">
              <span className="company-amp">&amp; Co.</span>
              <span className="company-sub">Analytics</span>
            </div>
          </div>
        </div>

        <Button
          id="new-analysis-btn"
          label="+ New Analysis"
          className="p-button-sm p-button-rounded new-analysis-btn"
          onClick={onNewAnalysis}
        />

        <div id="session-list" className="session-list">
          {children}
        </div>

        <div className="sidebar-footer">
          <div style={{width: "calc(100% - 90px)"}}>
            <div id="user-label" className="sidebar-user-name">
              {userName}
            </div>
            <div id="role-label" className="sidebar-user-role">
              {userRole}
            </div>
          </div>

          <Button
            id="logout-btn"
            label="Logout"
            className="p-button-text logout-btn"
            onClick={() => setLogoutVisible(true)}
          />
        </div>
      </div>

      {/* Logout Confirmation Dialog */}
      <Dialog
        header="Confirm Logout"
        visible={logoutVisible}
        onHide={() => setLogoutVisible(false)}
        modal
        style={{ width: "360px" }}
        className="logout-dialog"
      >
        <p>Are you sure you want to logout?</p>

        <div className="p-dialog-footer">
          <Button
            label="Cancel"
            className="p-button-text"
            onClick={() => setLogoutVisible(false)}
          />
          <Button
            label="Logout"
            className="p-button-danger"
            onClick={confirmLogout}
          />
        </div>
      </Dialog>
    </>
  );
};
